import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useResponsive } from '../contexts';
import { PreviewState } from './ClientOnboarding.utils';
const CobConfigContext = /*#__PURE__*/ createContext(undefined);
export function CobConfigProvider(props) {
    const { relationship, children, isPreviewModal, previewState, originalPreviewState } = props;
    const { isMobile } = useResponsive();
    const { CLIENT_PREVIEW_DEVICE_TOGGLE = false } = useFeatureFlags();
    const value = useMemo(()=>({
            relationship,
            isPreviewModal: !!isPreviewModal,
            isPreview: !!previewState,
            // On mobile, show setup brand only when device toggle feature is enabled
            isSetupBrand: previewState === PreviewState.SetupBrand && (!isMobile || CLIENT_PREVIEW_DEVICE_TOGGLE),
            originalPreviewState
        }), [
        relationship,
        previewState,
        isPreviewModal,
        isMobile,
        CLIENT_PREVIEW_DEVICE_TOGGLE,
        originalPreviewState
    ]);
    return /*#__PURE__*/ _jsx(CobConfigContext.Provider, {
        value: value,
        children: children
    });
}
export function useCobConfig() {
    const context = useContext(CobConfigContext);
    if (!context) throw new Error('useCobConfig must be used within a CobConfigProvider');
    return context;
}
